import * as SwitchPrimitive from "@radix-ui/react-switch"
import type { ComponentProps } from "react"

import { cn } from "~/lib/utils"

function Switch({
	className,
	...props
}: ComponentProps<typeof SwitchPrimitive.Root>) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={cn(
				"hover:cursor-pointer peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-background-tertiary focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 border-button-edge shadow-recessed transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
				className
			)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				data-slot="switch-thumb"
				className={cn(
					"bg-text-main data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 shadow-button transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
				)}
			/>
		</SwitchPrimitive.Root>
	)
}

export { Switch }
